export function applyProjectAdminSettingsToGanttStore(GanttStore, projectAdminSettings) {
  if (!GanttStore || !projectAdminSettings) return
  
  console.log("Project Admin Settings: ", projectAdminSettings);

  // autoUpdate is enabled on default
  GanttStore.IsAutoUpdateEnabled.set(projectAdminSettings.isAutoUpdateEnabled === undefined ? true : projectAdminSettings.isAutoUpdateEnabled)

  // preventMistakes is disabled on default
  GanttStore.PreventMistakes.set(!!projectAdminSettings.isPreventMistakeEnabled)

  // orderGanttEnableResultInput is disabled on default
  GanttStore.OrderGanttEnableResultInput.set(!!projectAdminSettings.isOrderGanttResultInputEnabled)
}

export async function updateProjectSettings(projectId, projectSettings, fetchErrorHandler, successCallback) {
  const response = await fetch(`/api/projects/${projectId}/settings`, {
    method: "PATCH",
    body: JSON.stringify(projectSettings),
    headers: {
      "Content-Type": "application/json",
    }
  })
  if (!response.ok) {
    return fetchErrorHandler(await response.json())
  }

  successCallback()
}
